
import React, { useState, useEffect, useRef } from "react";
// import Header from "../common/components/Header";
import { useNavigate } from "react-router-dom"; // Add this at the top
import Cartwaiter from "./Cartwaiter";
import Foodandbeveragesadvertise from '../FoodandBeverages/Foodandbeveragesadvertise';

import { Link } from "react-router-dom";
import { useLoader } from "../../../context/LoaderProvider.jsx";
import 'semantic-ui-css/semantic.min.css';
import axios from 'axios';
import allCartsImage from "../../../images/products/meals.jpg";

// import Biryanidata from './Biryanidata';
const TableCart = () => {

    const [quantities, setQuantities] = useState({});
    const navigate = useNavigate(); // Define navigate
    const [filteredItems, setFilteredItems] = useState([]);
    const [cartData, setCartData] = useState([]);
    const [allCategories, setAllCategories] = useState(["Allcarts"]);
    const [activeCategory, setActiveCategory] = useState("Allcarts");
    // Fetch Cart Data
    // Fetch Cart Data
    const isMobile = window.innerWidth <= 768;
    const [selectedDishId, setSelectedDishId] = useState(null); // Store the selected dishId
    const [cartItems, setCartItems] = useState([]);
    const [selectedCartId, setSelectedCartId] = useState(null);
    const [refresh, setRefresh] = useState(false);  // ✅ Define refresh state
    const { showLoader, hideLoader } = useLoader();
    const baseUrl = "https://backend.maamaas.com/food/";
    const [containerWidth, setContainerWidth] = useState(
        window.innerWidth > 1320 ? '180px' : window.innerWidth > 1000 ? '120px' : '100px'
    );

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 1320) {
                setContainerWidth('180px');
            } else if (window.innerWidth > 1000) {
                setContainerWidth('120px'); // 👈 smaller width between 1000–1320px
            } else {
                setContainerWidth('100px');
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const handleCategoryClick = (category) => {
        setActiveCategory(category);

        // Ensure React updates the state immediately
        setFilteredItems(prevItems => {
            if (category === "Allcarts") return cartData;
            return cartData.filter(item => item.dishName === category);
        });

        // 🔥 Force Re-Render Immediately
        setTimeout(() => setRefresh(prev => !prev), 0);
    };

    // ✅ Trigger re-fetch when `refresh` changes
    useEffect(() => {
        let selectedItems = activeCategory === "Allcarts"
            ? cartData
            : cartData.filter(item => item.dishName === activeCategory);

        setFilteredItems([...selectedItems]);
    }, [activeCategory, cartData, refresh]); // ✅ Added `refresh` to dependencies

    useEffect(() => {
        if (!selectedCartId || !selectedDishId) {
            console.warn("⏳ Waiting for selectedCartId and selectedDishId to be set...");
            return;
        }
        console.log("✅ selectedCartId and selectedDishId are now available");
    }, [selectedCartId, selectedDishId]); // ✅ Runs when these values change

    // ✅ Effect to Filter Items When `activeCategory` Changes


    // ✅ Effect to Fetch API Data When IDs and Category Are Set


    useEffect(() => {
        console.log("📡 useEffect triggered to fetch cart data");

        const fetchCart = async () => {
            const userId = localStorage.getItem("userId");
            const vendorId = localStorage.getItem("vendorId") || "1";
            const token = localStorage.getItem("authToken");

            console.log("🔍 LocalStorage values:", { userId, vendorId, token });

            try {
                showLoader();
                const response = await fetch(`https://backend.maamaas.com/food/cart/get/${vendorId}`, {
                    headers: token ? { Authorization: `Bearer ${token}` } : {},
                });

                const tokenFromHeader = response.headers.get("authorization");
                if (tokenFromHeader) {
                    localStorage.setItem("authToken", tokenFromHeader);
                }

                const data = await response.json();

                if (data.token) {
                    localStorage.setItem("authToken", data.token);
                }

                console.log("🛒 Cart Data:", data);

                const cartItems = data.cartItems || [];

                setCartData(cartItems);
                setAllCategories(["Allcarts", ...new Set(cartItems.map(item => item.dishName))]);
                setFilteredItems(cartItems);

            } catch (err) {
                console.error("❌ Error fetching cart data:", err);
            } finally {
                hideLoader();
            }
        };

        fetchCart();
    }, []);

    useEffect(() => {
        const fetchCartData = async () => {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken"); // include if API requires auth
            const seatingId = localStorage.getItem("seatingId");


            if (!vendorId) {
                console.error("🚨 Vendor ID not found in localStorage!");
                return;
            }

            try {
                showLoader();
                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/cart/getby/table/${vendorId}/${seatingId}`,
                    {
                        headers: token ? { Authorization: `Bearer ${token}` } : {},
                    }
                );

                console.log("🛒 Cart Data:", response.data);

                const items = response.data.cartItems || [];
                setCartData(items);
                setFilteredItems(items);

                // Extract unique categories (dishName or category field)
                const categories = [...new Set(items.map(item => item.dishName))];
                setAllCategories(["Allcarts", ...categories]);

                // Handle quantities
                const savedQuantities = JSON.parse(localStorage.getItem("cartQuantities") || "{}");
                const updatedQuantities = {};

                items.forEach((item) => {
                    const dishId = item.itemId || item.dishId || item.id;
                    updatedQuantities[dishId] = item.quantity ?? item.qty ?? savedQuantities[dishId] ?? 1;
                });

                setQuantities(updatedQuantities);
                localStorage.setItem("cartQuantities", JSON.stringify(updatedQuantities));

            } catch (error) {
                console.error("❌ Error fetching cart data:", error);
                if (error.response) {
                    console.error("📛 Response Error:", error.response.data);
                } else if (error.request) {
                    console.error("📛 No Response from server:", error.request);
                } else {
                    console.error("📛 General Error:", error.message);
                }
            } finally {
                hideLoader();
            }
        };

        fetchCartData();
    }, []);


    useEffect(() => {
        if (activeCategory === "Allcarts") {
            setFilteredItems(cartData); // ✅ Show all items
        } else {
            const filtered = cartData.filter(item => item.dishId === activeCategory);
            setFilteredItems(filtered);
        }
    }, [activeCategory, cartData]); // ✅ Depend on activeCategory and cartData





    return (
        <>
            <div className="container-fluid">
                <div className="row" style={{ marginTop: "50px" }}>
                    <div className="col-lg-2 col-md-3 col-sm-3 col-3">
                        {/* 📌 Desktop View: Category Cards */}
                        <div
                            className="category-sidebar d-none d-sm-block mobile-scrolling-cart"  // Hide on mobile
                            style={{
                                maxHeight: "600px",
                                position: "sticky",
                                top: "0px",
                                marginTop: "5px",
                                zIndex: 1000,
                                width: containerWidth,
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                            }}
                        >
                            <div className="category-container" style={{
                                overflowY: "auto",
                                height: "556px",
                                marginTop: "68px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                            }}>
                                {allCategories.map((category, index) => {
                                    const item = cartData.find(i => i.dishName === category);
                                    const categoryImage =
                                        category === "Allcarts"
                                            ? allCartsImage
                                            : item?.dishImage
                                                ? `${baseUrl}${item.dishImage}`
                                                : "/placeholder.svg";


                                    return (
                                        <div
                                            key={index}
                                            className="category-card"
                                            onClick={() => handleCategoryClick(category)}
                                            style={{
                                                backgroundColor: activeCategory === category ? "rgb(177 93 198)" : "#D9D9D9",
                                                margin: "8px 0",
                                                padding: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                cursor: "pointer",
                                                justifyContent: "center",
                                                borderRadius: "15px",
                                                transition: "0.3s ease-in-out",
                                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                                height: "165px",
                                            }}
                                        >
                                            <img
                                                src={categoryImage}
                                                alt={category}
                                                style={{
                                                    width: "100px",
                                                    height: "100px",
                                                    borderRadius: "50%",
                                                    objectFit: "cover",
                                                }}
                                                onError={(e) => { e.target.src = allCartsImage; }} // fallback if broken
                                            />


                                            <div className="category-card-body d-flex justify-content-center p-0">
                                                <button
                                                    style={{
                                                        backgroundColor: activeCategory === category ? "#ddd" : "#fff",
                                                        margin: "5px",
                                                        padding: "8px",
                                                        borderRadius: "10px",
                                                        cursor: "pointer",
                                                        transition: "0.3s ease-in-out",
                                                    }}
                                                >
                                                    {category}
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })}



                            </div>
                        </div>

                        {/* 📌 Mobile View: Dropdown */}


                    </div>
                    <div className="d-block d-sm-none " style={{ marginTop: "65px", width: "100%" }}>
                        <select
                            className="form-control "
                            onChange={(e) => handleCategoryClick(e.target.value)}
                            value={activeCategory}
                            style={{
                                padding: "8px",
                                borderRadius: "10px",
                                border: "1px solid #ccc",
                                width: "100%",
                                background: "#b15dc6",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "20px"
                            }}
                        >
                            {allCategories.map((category, index) => (
                                <option key={index} value={category}>
                                    {category}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-lg-7 col-md-7 col-sm-12 col-12" >
                        <p
                            className="breadcrumb maamaas-home-bredcum"
                            style={{
                                position: "fixed",
                                top: isMobile ? "50px" : "80px",
                                left: isMobile ? "5px" : "18vw",
                                width: "100%",
                                backgroundColor: "#fff",
                                zIndex: 1000,
                                padding: "10px 0",
                                fontSize: isMobile ? "14px" : "18px",
                                fontWeight: isMobile ? "normal" : "bold",
                                textAlign: "center",
                                margin: 0,

                            }}
                        >
                            {/* <Link
                                to="/Newmainlandingpage"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Home
                            </Link>
                            <span className="separator"> &gt; </span> */}
                            <Link
                                to="/foodladingpage"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Food & Beverages
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link
                                to="/table"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Table
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link
                                to="/waitermenu"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Menu
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link
                                // to="/cartsdata"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Cart
                            </Link>

                        </p>
                        <div className="cartsizes"
                            style={{
                                marginTop: "100px",
                                padding: "20px",
                                borderRadius: "8px",
                            }}
                        >
                            {/* ✅ Show Ordercart Component When a Category is Clicked */}
                            {/* {filteredItems.length > 0 && ( */}
                            <Cartwaiter key={activeCategory} filteredDataProp={filteredItems} />



                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                            <Foodandbeveragesadvertise />
                        </div>

                    </div>


                </div>



            </div>
        </>
    );
};

export default TableCart;
